import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideNavBar from "pages/homeDashboard/NavBar/sideNavBar";

import Errors from "components/Errors/Errors";
import Footer from "components/Footer/Footer";
import NavBar from "components/navigation/NavBar";

const Layout = () => {
  const location = useLocation();
  const showSideNav =
    ["/dashboard", "/global-orgs", "/docs"].includes(location.pathname) ||
    location.pathname.startsWith("/docs/") ||
    location.pathname.startsWith("/ops-dashboard");

  return (
    <div style={{ minHeight: "100vh", width: "100vw" }}>
      <NavBar /> {/* Top navbar stays at the top */}
      <div style={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
        {showSideNav && <SideNavBar />}
        <div style={{ flex: 1, minHeight: "100vh" }}>
          {location.pathname.includes("admin") ? null : <Errors />}
          <Outlet />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;